export const BEARER_PREFIX = 'Bearer ';

/** Signed URL expiration time: 1 hour */
export const SIGNED_URL_EXPIRATION_MS = 60 * 60 * 1000;

/** Data provider backends */
export const DataProviderBackend = {
  MONGODB: 'mongodb',
  FIRESTORE: 'firestore',
} as const;
export type DataProviderBackend = (typeof DataProviderBackend)[keyof typeof DataProviderBackend];

export function parseBool(value: string | null): boolean {
  return value === 'true';
}
